import type { IconProps } from '../types/IconProps.ts';
export const MailOpen: IconProps = {
    name: 'MailOpen',
    children: [
        `<path d="M2 10.9a2 2 0 0 1 .66-1.5l8-7.2a2 2 0 0 1 2.68 0l8 7.2a2 2 0 0 1 .66 1.5V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z" />`,
        `<path d="m3 10 7.9 5.26a2 2 0 0 0 2.2 0L21 10" />`,
    ]
};